// extracted by mini-css-extract-plugin
export default {"mCard":"CA-z","image":"DA-z","imageNoBackground":"EA-z","imageHasCategory":"FA-z","fullWidth":"GA-z"};